// Shared contacts block: phone + SMS consent, e-mail + email consent

import Input from './Input';
import EmailConsentCheckBox from './EmailConsentCheckBox';
import SmsConsentCheckBox from './SmsConsentCheckBox';
import './ContactsFields.scss';

export default function ContactsFields({ formik, emailDisabled, consentDisabled }) {
  return (
    <div className='contacts-wrap'>
      <div className='phone-consent'>
        <Input
          name='phone'
          placeholder='Phone'
          {...formik.getFieldProps('phone')}
          error={
            formik.touched.phone && formik.errors.phone
              ? formik.errors.phone
              : null
          }
        />
        <SmsConsentCheckBox
          value={formik.values.smsConsent}
          onChange={(v) => formik.setFieldValue('smsConsent', v)}
          disabled={consentDisabled}
        />
      </div>
      <div className='email-consent'>
        <Input
          name='email'
          placeholder='E-mail'
          {...formik.getFieldProps('email')}
          error={
            formik.touched.email && formik.errors.email
              ? formik.errors.email
              : null
          }
          disabled={emailDisabled}
        />
        <EmailConsentCheckBox
          value={formik.values.emailConsent}
          onChange={(v) => formik.setFieldValue('emailConsent', v)}
          disabled={consentDisabled}
        />
      </div>
    </div>
  );
}
